<template>
  <div>    
      <div class="row">
        <div class="col-md-12" style="margin-top: -40px;">
            <graficodoughnut    :rotulo="'DETALHES:'"
                                :legendas="legendastecnicos"
                                :dados="dadostecnicos"
            ></graficodoughnut>
        </div>
        <!-- - Exibição dos técnicos e seus dados-->
        <div class="col-md-12">
            <ul style="padding-left: 0px; margin-bottom: 0px; margin-top: -40px; height: 61px; overflow:auto;">
                <li v-for="(item, indice) in dadostecnicos" :key="indice" class="li-item-card-dash" style="height: 15px;">
                    <span class="txt-item-card-dash-grafico">{{item.name }}</span>
                    <span class="txt-item-card-dash-grafico" style="float: right;">
                        {{ mtdformatavalordecimal(parseFloat(item.value)) }}
                    </span>
                </li>
            </ul>                                            
        </div>
    </div>    
  </div>
</template>

<script>

import util from '../../utilitarios/util';
import GraficoDoughnut from '../../components/cmpgraficodoughnut.vue';
import Skeletondashboard from '../../components/cmpskeletondashboard2.vue';
export default {
  name: "demvendedores",

  components:{
    'graficodoughnut'       : GraficoDoughnut,
    'dashboard_skeleton'   : Skeletondashboard
  },

  data : function name(params) {
    return {
        legendastecnicos : [],
       
        margemlucrogeral        : 0,
        showpopover             : false,
        isloading               : false,  
        vtotalservicos          : 0,
        mediafaturamento        : 0,
        usuariologado           : this.$store.state.usuario,

        dadostecnicos           : []
    }   
  },
  props: [
     'utodasfiliais',
     'idfilialmeta',
     'pdtini',
     'pdtfim',
     'lstfiliais',
  ],
  methods:{
        hidepopover(){
          setTimeout(() => {
            this.showpopover = false;
          }, 200); 
        },
        mtdformatavalordecimal(valor){
				  return util.formatarvalor(valor, '');
        },
       mtdresultadofaturamento(){
          var vself           = this;
        
          vself.$emit('handlerLoader', true);
          let periodo         = '"' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
      
 
          let parametros      = [
              {parametro: 'idclientesac', valor : window.localStorage.getItem('idcliente')},
              {parametro: 'op',           valor : 'dash'},
              {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},                    
              {parametro: 'periodo',      valor : periodo},
              {parametro: 'usuariologado',valor : JSON.stringify(vself.usuariologado)},
              {parametro: 'filiais',      valor : JSON.stringify(vself.lstfiliais)},
              {parametro: 'diasemana',    valor : util.diasemanaintmysql()},
              {parametro: 'filtrotarefas',valor : ''},//' and t.sttarefa=0'},
              {parametro: 'patharquivos', valor : ''},
          ];
          let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/dashboard.php');
          retorno.then(function (response) {
           
            vself.dadostecnicos = [];
            response.data.tecnicos.forEach(element => {
                console.log(element);
                vself.dadostecnicos.push(
                    {value: parseFloat(element.valor_servico), name: element.nome, media: parseFloat(element.valor_servico)}
                );
            });
            vself.legendastecnicos  = util.gerardadoslegendagrafico(vself.dadostecnicos);
            
              vself.$emit('handlerLoader', false);										
          }).catch(function (response) {
              vself.dadosvendedores = [];
              //loader.hide();
              vself.$emit('handlerLoader', false);	
          });                
      },
  },
  mounted(){


    setTimeout(() => {
         this.mtdresultadofaturamento();
    }, 3000);
   
  },
  computed:{
            
  },
}
</script>
